<template>
  <div class="time_picker">
    <van-field class="after_field_border"
      v-model="durationDiaplay"
      type="text"
      clearable
      label="跑步用时"
      placeholder="请选择跑步用时"
      readonly
      @click="show=true"
    ><div class="right-label" slot="right-icon"></div></van-field>

    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="show=false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Picker, Popup } from 'vant'
import { padding } from '@/utils/index'

export default {
  name: 'TimePicker',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    value: {
      type: Number
    }
  },
  components: {
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup
  },
  data () {
    let hours = []
    for (let index = 0; index <= 20; index++) {
      hours.push(index + '小时')
    }

    let minutes = []
    for (let index = 0; index < 60; index++) {
      minutes.push(index + '分钟')
    }

    let seconds = []
    for (let index = 0; index < 60; index++) {
      seconds.push(index + '秒')
    }

    return {
      show: false,
      columns: [
        {
          values: hours
        },
        {
          values: minutes
        },
        {
          values: seconds
        }
      ],
      durationDiaplay: '',
      duration: ''
    }
  },
  created () {
  },
  methods: {
    onConfirm (value, index) {
      const hours = padding(index[0] + '', 2)
      const minutes = padding(index[1] + '', 2)
      const seconds = padding(index[2] + '', 2)

      this.durationDiaplay = `${hours}:${minutes}:${seconds}`
      this.duration = index[0] * 3600 + index[1] * 60 + index[2]
      this.$emit('confirm', this.duration)
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.right-label {
  width: 80px;
}
</style>
